import { render } from "./Historic.vue?vue&type=template&id=6ec9c412&scoped=true"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"

import "./Historic.vue?vue&type=style&index=0&id=6ec9c412&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec9c412"]])

export default __exports__